import React from 'react';
import { StyleSheet } from 'react-native';
import { TYPE_CONFIG, SPACING } from '@garnish/constants';
import { NumberField } from '../../NumberField';

export const NumberFieldCode = (props: TextFieldCodeProps) => {
  const { style, label = 'Enter code', ...restProps } = props;
  const codeVariationStyles = [styles.codeVariation, style];

  return (
    <NumberField
      label={label}
      clearButtonType="none"
      style={codeVariationStyles}
      labelOffset={SPACING.medium}
      {...restProps}
    />
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type TextFieldCodeProps = React.ComponentProps<typeof NumberField>;

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  codeVariation: {
    ...TYPE_CONFIG.DISPLAY['32'],
    fontFamily: TYPE_CONFIG.BODY['16'].fontFamily,
    letterSpacing: SPACING.medium,
    lineHeight: 40,
  },
});
